// --- External tools
import axios from 'axios';

// --- Logic
import { commonConfiguration } from 'io/API';
import { onRequestError } from 'io/API/errorHandling';


const getAdCategories = contextConfiguration => axios.get(
	'/ad_categories',
	{
		...commonConfiguration,
		...contextConfiguration,
	}
).catch(onRequestError);

export default getAdCategories;
